<div class="d-flex flex-wrap gap-2 align-items-center">
  @for (formDurationDisplay of formDurationDisplays; track formDurationDisplay.formUnit) {
    @let formUnit = formDurationDisplay.formUnit;
    <div class="form-group">
      @if (showLabel) {
        <label class="form-label" [for]="formUnit">{{formDurationDisplay.label | messageTranslate}}</label>
      }
      <div class="input-group">
        <input type="number"
               class="form-control hide-spin-buttons duration-input"
               [id]="formUnit"
               [formControl]="durationForm.controls[formUnit]" />
        <span class="input-group-text">{{formDurationDisplay.labelAbbreviated | messageTranslate}}</span>
      </div>
    </div>
  }
  <div class="form-group">
    @if (showLabel) {
      <label class="form-label">&nbsp;</label>
    }
    @if (clearable) {
      <fa-icon icon="times"
               class="clickable d-block"
               [fixedWidth]="true"
               [title]="'Clear duration' | messageTranslate"
               (click)="clearDuration()" />
    }
  </div>
</div>
<app-errors [errors]="durationForm.errors" />
